import { portalHomeBeforeEnter } from "./portalHomeAccess";

const portalPromotionDetailPage = () =>
  import(
    /* webpackChunkName: "portal-promotion-detail" */ "@/views/PortalPromotionDetailPage.vue"
  );

export default [
  {
    path: "/promotions/:slug",
    name: "portalPromotionDetail",
    component: portalPromotionDetailPage,
    beforeEnter: portalHomeBeforeEnter,
    meta: {
      authRequired: true,
    },
    props: true,
  },
];
